import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';

const ImmigrationProvidersFormatter = (cellProps: CellProps) => {
  if (!cellProps.row?.immigrationProviders?.length) {
    return <CellEventsHandler cellProps={cellProps}>None</CellEventsHandler>;
  }
  return <CellEventsHandler cellProps={cellProps}>{cellProps.row.immigrationProviders.join(', ')}</CellEventsHandler>;
};

export const ImmigrationProvidersColumn = (): IColumn => ({
  item: {
    key: 'immigrationProviders',
    name: 'Immigration',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(112px, 1fr)',
    formatter: ImmigrationProvidersFormatter,
  },
  visible: ({ isImmigrationProvidersVisible }) => isImmigrationProvidersVisible!,
});
